var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSteps = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 22
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 4a2.006 2.006 0 0 0 2-2 2.006 2.006 0 0 0-2-2 2.006 2.006 0 0 0-2 2c0 1.1.9 2 2 2M3.8 7.906 1 22h2.1l1.8-7.996L7 16.002V22h2v-7.497l-2.1-1.999.6-2.999a7.32 7.32 0 0 0 5.5 2.5v-2c-1.9 0-3.5-.999-4.3-2.4l-1-1.598a2.146 2.146 0 0 0-2.65-.84L0 7.307v4.699h2v-3.4z"
})));
export { SvgSteps as ReactComponent };
export default __webpack_public_path__ + "5e449e63b75774d65049fb0f8ab95eb2.svg";